


















import { computed, defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { CurrencyCost } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { getMainCurrencyCode } from "@/lib/moneyHelpers";
import FormatMoney from "@/components/FormatMoney";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationSubscriptionPurchase",
  components: { NotificationItemView, FormatMoney },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const price = computed<number | null>(() => {
      const costs = props.notification.details.costs;
      return costs.find((cost: CurrencyCost) => cost.currency === getMainCurrencyCode())?.cost ?? null;
    });

    return {
      price,
    };
  },
});
